import React from 'react'
import { useLatestNews, LatestNewsProps } from './useLatestNews'
import styles from './LatestNews.module.scss'
import LatestNewsItem from 'components/LatestNews/LatestNews'

const LatestNews: React.FC<LatestNewsProps> = (props: LatestNewsProps) => {
  const { latestNews, isAr, t } = useLatestNews(props)

  return (
    <div className={`${styles['latest-news']} col-xl-4`}>
      <h4 className={styles.title}>{t('latestNews')}</h4>
      {latestNews && latestNews.length ? (
        latestNews.map((news, index) => (
          <LatestNewsItem
            key={`news-${news.id}-${index}`}
            image={news.image}
            title={isAr ? news.titleAr : news.titleEn}
            link={`/NewsDetails/${news.slugAr}`}
            date={news.publishedAt.split('T')[0]}
            isWhite
          />
        ))
      ) : (
        <div className='col-12 fs-4 fw-bold py-5'>{t('noData')}</div>
      )}
    </div>
  )
}

export default LatestNews
